import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import React, { forwardRef, useMemo } from 'react';
import 'focus-visible';
import { CardSection } from './CardSection.js';
import { themed } from '@indeed/ifl-css';
import transition from '../../utils/transition.js';
import { matchesDisplayName } from '../../utils/displayName.js';
import { jsx } from '@emotion/react';

const CARD_DEFAULT_TAG = "div";
const StyledCard = /*#__PURE__*/themed(CARD_DEFAULT_TAG, process.env.NODE_ENV === "production" ? {
  styleProps: ["selected"],
  shouldForwardProp: prop => prop !== "selected",
  target: "esu7hk30"
} : {
  styleProps: ["selected"],
  shouldForwardProp: prop => prop !== "selected",
  target: "esu7hk30",
  label: "StyledCard"
})(_ref => {
  let {
    selected
  } = _ref;
  return [{
    bg: "background",
    border: "1px solid",
    borderColor: "border.weak",
    borderRadius: "md",
    display: "block",
    overflow: "hidden",
    whiteSpace: "normal"
  }, selected !== undefined && {
    cursor: "pointer",
    boxShadow: "none",
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.default, "border-color", "background-color", "box-shadow");
    },
    ":focus": {
      outline: "none",
      boxShadow: "focus"
    },
    ":focus:not([data-focus-visible-added])": {
      boxShadow: "none"
    },
    "&:hover, &:hover:focus:not([data-focus-visible-added])": {
      boxShadow: "low"
    },
    "&:active, &:active:focus, &:active:focus:not([data-focus-visible-added])": {
      boxShadow: "inset"
    }
  }, selected === true && {
    boxShadow: "medium",
    borderColor: "border.primary",
    ":focus:not([data-focus-visible-added])": {
      boxShadow: "medium"
    }
  }];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * @see https://experience.indeed.design/components/ids/card
 */
const Card = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    children,
    ...props
  } = _ref3;
  const tabIndex = props.selected !== undefined ? 0 : undefined;
  const wrapChildren = useMemo(() => {
    if (!children) return true;

    // Check if any direct child is a CardSection
    const childrenArray = React.Children.toArray(children);
    return !childrenArray.some(child => matchesDisplayName([CardSection], child));
  }, [children]);
  return jsx(StyledCard, _extends({
    ref: ref,
    tabIndex: tabIndex
  }, props), wrapChildren ? jsx(CardSection, null, children) : children);
});

export { CARD_DEFAULT_TAG, Card };
